<template>
  <div
    class="container-nav ml-md-0"
    :class="screen === 'small' ? 'bg-black' : 'bg-red'"
  >
    <nav class="navbar navbar-expand-md navbar-light d-flex mt-md-4">
      <div :class="screen === 'big' ? 'd-none' : 'd-block'">
        <button
          class="navbar-toggler icon d-flex align-items-center"
          :class="screen === 'big' ? 'icon-big' : ''"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <!-- <span class="navbar-toggler-icon" :class="screen === 'big'? 'navbar-toggler-icon-big' : ''"></span> -->
          <icon
            name="bars"
            :color="screen === 'big' ? '#00000066' : 'white'"
            :width="screen === 'big' ? '30' : '23'"
            :height="screen === 'big' ? '30' : '20'"
          ></icon>
        </button>
      </div>

      <div
        class="collapse navbar-collapse uppercase"
        id="navbarSupportedContent"
      >
        <ul class="nav navbar-nav mr-auto">
          <li class="nav-item dropdown2 ml-md-4">
            <div class="d-flex align-items-center nav-link">
              <img
                style="height: 15px;"
                class="img-fluid mr-1"
                :src="'/images/drapeau_' + $i18n.locale.toLowerCase() + '.png'"
                alt=""
              />
              <a
                :class="{
                  'ml-1': true,
                  'color-white': true,
                  'nav-item-hover': true,
                  'nav-item-hover-over': dropdown2Lang
                }"
                href="#"
                id="navbarDropdown"
                role="button"
                @mouseover="dropdownOver('dropdown2Lang')"
                @mouseleave="dropdownLeave('dropdown2Lang')"
                @click="dropdownClick('dropdown2Lang')"
              >
                {{ $i18n.locale }}
              </a>
            </div>
            <div
              class="dropdown2-menu"
              v-if="dropdown2Lang"
              role="menu"
              @mouseover="dropdownMenuOver('dropdown2Lang')"
              @mouseleave="dropdownMenuLeave('dropdown2Lang')"
            >
              <a @click="changeLang('fr')" class="dropdown2-item">Français</a>
              <a @click="changeLang('en')" class="dropdown2-item">English</a>
              <a @click="changeLang('ru')" class="dropdown2-item">Russe</a>
            </div>
          </li>
        </ul>
        <ul class="navbar-nav mr-auto ">
          <li class="nav-item invisible" ref="refHome">
            <router-link class="nav-link nav-item-hover " to="/">
              {{ $t("translation.Accueil") }}
            </router-link>
          </li>
          <li class="nav-item dropdown2 invisible" ref="refSell">
            <a
              :class="{
                'nav-link': true,
                'nav-item-hover': true,
                'nav-item-hover-over': dropdown2Sell
              }"
              href="#"
              id="navbarDropdown"
              role="button"
              @mouseover="dropdownOver('dropdown2Sell')"
              @mouseleave="dropdownLeave('dropdown2Sell')"
              @click="dropdownClick('dropdown2Sell')"
            >
              {{ $t("translation.Ventes") }}
            </a>
            <div
              class="dropdown2-menu "
              v-if="dropdown2Sell"
              role="menu"
              @mouseover="dropdownMenuOver('dropdown2Sell')"
              @mouseleave="dropdownMenuLeave('dropdown2Sell')"
            >
              <a @click="goOfferList('monaco', 1)" class="dropdown2-item "
                >MONACO</a
              >
              <a @click="goOfferList2('france', 1)" class="dropdown2-item">{{
                $t("translation.Cote_dazur")
              }}</a>
              <a
                @click="goOfferList2('international', 1)"
                class="dropdown2-item"
                >{{ $t("translation.international") }}</a
              >
            </div>
          </li>
          <li class="nav-item  dropdown2 invisible" ref="refRent">
            <a
              :class="{
                'nav-link': true,
                'nav-item-hover': true,
                'nav-item-hover-over': dropdown2Rent
              }"
              href="#"
              id="navbarDropdown"
              role="button"
              @mouseover="dropdownOver('dropdown2Rent')"
              @mouseleave="dropdownLeave('dropdown2Rent')"
              @click="dropdownClick('dropdown2Rent')"
            >
              {{ $t("translation.Locations") }}
            </a>
            <div
              class="dropdown2-menu  "
              v-if="dropdown2Rent"
              role="menu"
              @mouseover="dropdownMenuOver('dropdown2Rent')"
              @mouseleave="dropdownMenuLeave('dropdown2Rent')"
            >
              <a @click="goOfferList('monaco', 2)" class="dropdown2-item"
                >MONACO</a
              >
              <a @click="goOfferList2('france', 2)" class="dropdown2-item">{{
                $t("translation.Cote_dazur")
              }}</a>
              <a
                @click="goOfferList2('international', 2)"
                class="dropdown2-item"
                >{{ $t("translation.international") }}</a
              >
            </div>
          </li>
          <li class="nav-item invisible" ref="refContact">
            <router-link class="nav-link nav-item-hover " to="/contact">
              {{ $t("translation.Contact") }}
            </router-link>
          </li>
        </ul>
        <!-- <ul class="navbar-nav  ">
          <li class="nav-item">
            <router-link
              class="nav-link d-flex flex-row align-items-center nav-item-hover"
              to="/offers/favories"
            >
              <icon name="heart" :scale="1.1" />
              <div class="ml-2">{{ $t("translation.Mes_favoris") }}</div>
            </router-link>
          </li>
        </ul> -->
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "navigation",
  props: {
    screen: String,
    internationalRent: Boolean,
    internationalSell: Boolean
  },
  data() {
    return {
      dropdown2Sell: false,
      dropdown2Rent: false,
      dropdown2Lang: false,
      dropdown2timer: null
    };
  },
  computed: {
    trad() {
      return this.$store.state.traductionsloaded;
    }
  },
  mounted() {
    // this.$refs.refSell.style.display = "none";
    // this.$refs.refRent.style.display = "none";
    // this.$refs.refHome.style.display = "none";
    // this.$refs.refContact.style.display = "none";
  },
  watch: {
    trad(newVal, oldVal) {
      if (newVal) {
        this.$refs.refSell.classList.remove("invisible");
        this.$refs.refRent.classList.remove("invisible");
        this.$refs.refHome.classList.remove("invisible");
        this.$refs.refContact.classList.remove("invisible");
        this.$forceUpdate();
      }
    }
  },
  methods: {
    goOfferList(where, num) {
      this.dropdown2Sell = false;
      this.dropdown2Rent = false;
      this.dropdown2Lang = false;

      this.$store.dispatch("cancelAllFilter");
      let filter = this.$_.cloneDeep(this.$store.state.offersfilters);
      if (where == "monaco") filter.monaco = true;
      if (where == "france") filter.france = true;
      if (where == "international") filter.international = true;
      if (num == 1) filter.sale = true;
      if (num == 2) filter.rent = true;
      this.$store.commit("set_offersfilters", filter);
      this.$router.push(
        "/offers/" + (filter.sale ? "sales" : "rents") + "/" + where
      );
    },
    goOfferList2(where, num) {
      // return this.goOfferList(where, num);
      this.dropdown2Sell = false;
      this.dropdown2Rent = false;
      this.dropdown2Lang = false;

      this.$store.dispatch("cancelAllFilter");
      let filter = this.$_.cloneDeep(this.$store.state.offersfilters);
      if (where == "monaco") filter.monaco = true;
      if (where == "france") filter.france = true;
      if (where == "international") filter.international = true;
      if (num == 1) filter.sale = true;
      if (num == 2) filter.rent = true;
      // /offers/france/sales/types-all/pieces-all/budget-all/1
      this.$store.commit("set_offersfilters", filter);
      this.$router.push(
        "/offers/" +
          where +
          "/" +
          (filter.sale ? "sales" : "rents") +
          "/types-all/pieces-all/budget-all/1"
      );
    },
    dropdownClick(what) {
      // console.log("je passe dropdownClick");
      this[what] = !this[what];
    },
    dropdownOver(what) {
      // console.log("je passe dropdownOver", screen.width);
      if (screen.width < 992) return;
      this.dropdown2Sell = false;
      this.dropdown2Rent = false;
      this.dropdown2Lang = false;
      if (this.dropdown2timer) clearTimeout(this.dropdown2timer);
      this[what] = true;
    },
    dropdownLeave(what) {
      // console.log("je passe dropdownLeave");
      this.dropdown2timer = setTimeout(() => {
        this[what] = false;
      }, 100);
    },
    dropdownMenuOver(what) {
      // console.log("je passe dropdownMenuOver");
      if (this.dropdown2timer) clearTimeout(this.dropdown2timer);
    },
    dropdownMenuLeave(what) {
      // console.log("je passe dropdownMenuLeave");
      if (this.dropdown2timer) clearTimeout(this.dropdown2timer);
      this.dropdown2timer = setTimeout(() => {
        this[what] = false;
      }, 100);
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      this.$store.commit("set_lang", lang);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";
.bg-red {
  background-color: #d71e29;
}
.bg-black {
  background-color: #201f1f;
}

.icon {
  text-align: center;
  width: 1.6em;
  height: 1.5em;
  color: white;
  border-color: White;
  padding: 0.15rem 0.21rem;
}
.icon-big {
  width: 2.5em;
  height: 2.5em;
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
  padding: 0.25rem 0.75rem;
}

.navbar-toggler-icon {
  width: 1em;
  height: 1em;
}
.navbar-toggler-icon-big {
  width: 1.5em;
  height: 1.5em;
}
</style>
